import { accountsAPI, usersAPI } from './../../api/projects-api';
import { handleRequestResponseError } from './../../utils/errorUtils/handleServerNetworkError';
import { AppRootState } from './../../app/store';
import { setAppStatusAC, setAppErrorAC } from './../../app/app-reducer';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserType } from '../Users/users-reducer';

const initialState = {
  accounts: [] as Array<AccountType>
}

export const getAccountsTC = createAsyncThunk('accounts/get', async (_, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    
    const res = await accountsAPI.getAccounts(token)
    console.log('Accounts RESP', res)
    thunkAPI.dispatch(setAccounts(res.data))
    res.data.forEach((account: AccountType) => {
      thunkAPI.dispatch(getUsersForAccountTC({accountId: account.id}))
    });
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: '' })
  }
})

export const getUsersForAccountTC = createAsyncThunk('accounts/getUsers', async (params: {accountId: number}, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    const res = await usersAPI.getUsersByAccount(token, params.accountId)
    console.log('USERS for Account', res.data)
    thunkAPI.dispatch(setUsersInAccounts({users: res.data, accountId: params.accountId}))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: '' })
  }
})

export const getAccountTC = createAsyncThunk('accounts/getSingle', async (params:{id:number}, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    
    const res = await accountsAPI.getAccount(token, params.id)
    console.log('Accounts RESP', res)
    thunkAPI.dispatch(setAccount(res.data))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: '' })
  }
})


export const updateAccountTC = createAsyncThunk('accounts/update', async ( params:{account: AccountType }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    //const res = await accountsAPI.updateAccount(token, params.account)
    const res = await accountsAPI.updateAccount(token, params.account.id, params.account.name, params.account.email, 
      params.account.description, params.account.isActive)

    thunkAPI.dispatch(getAccountsTC())
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    thunkAPI.dispatch(setAppErrorAC({error: `The account "${params.account.name}" was updated!`, color:'success'}))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: '' })
  }
})

export const deleteAccountTC = createAsyncThunk('accounts/get', async (params: {account: AccountType}, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    
    const res = await accountsAPI.deleteAccount(token, params.account.id)
    console.log('Accounts RESP', res)
    thunkAPI.dispatch(getAccountsTC())
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    thunkAPI.dispatch(setAppErrorAC({error: `The account:  ${params.account.name} was deleted!`, color:'success'}))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: '' })
  }
})

const slice = createSlice({
  name: 'accounts',
  initialState: initialState,
  reducers: {
    setAccounts(state, action: PayloadAction<Array<AccountType>>){
      state.accounts = action.payload
    },
    setAccount(state, action: PayloadAction<AccountType>){
      let account = state.accounts.find(acc => acc.id === action.payload.id)
      account = action.payload
    },
    setUsersInAccounts(state, action: PayloadAction<{accountId: number, users: Array<UserType>}>){
      let acc = state.accounts.find(acc => acc.id === action.payload.accountId)
      if(acc) {
        acc.users = action.payload.users
      } 
    },
  }
})

export const accountsReducer = slice.reducer
export const {setAccounts,setAccount, setUsersInAccounts} = slice.actions

export type AccountType = {
  id: number
  name: string
  email: string
  description: string
  isTrial: boolean
  isActive: boolean
  //setActive: Date
  users: Array<UserType>
  rowVersion: string
}
